import * as c3 from "c3";
import * as $ from "jquery";
import "pivottable";

// tslint:disable-next-line:no-shadowed-variable
const sanitise = function sanitise(str: any) {
  return typeof str === "string"
    ? str.replace(/</g, "&lt;").replace(/>/g, "&gt;")
    : str;
};

let fullAggName = "";
export class C3Renderes {
  public c3Renderers = {
    "Area Chart": this.makeC3Chart({
      stacked: true,
      type: "area",
    }),
    // tslint:disable-next-line: object-literal-sort-keys
    "Bar Chart": this.makeC3Chart({
      type: "bar",
    }),
    "Donut Chart": this.makeC3Chart({
      type: "donut",
    }),
    "Horizontal Bar Chart": this.makeC3Chart({
      horizontal: true,
      type: "bar",
    }),
    "Horizontal Stacked Bar Chart": this.makeC3Chart({
      horizontal: true,
      stacked: true,
      type: "bar",
    }),
    "Line Chart": this.makeC3Chart({
      type: "line",
    }),
    "Pie Chart": this.makeC3Chart({
      type: "pie",
    }),
    "Stacked Bar Chart": this.makeC3Chart({
      stacked: true,
      type: "bar",
    }),
  };

  public C3Renderes() {
    // Do nothing
  }

  public makeC3Chart(chartOpts: any) {
    if (chartOpts == null) {
      chartOpts = {};
    }
    return (pivotData: any, opts: any) => {
      // tslint:disable-next-line: prefer-const
      let params;
      let rotationAngle;
      let vAxisTitle;
      let keys: { rowKeys: any; colKeys: any; columns: any; headers: any };
      const defaults = {
        c3: {},
        localeStrings: {
          by: "by",
          vs: "vs",
        },
      };
      let showCrashMessage = false;
      let showNoDataMessage = false;
      if (pivotData.colKeys && pivotData.colKeys.length > 0) {
        rotationAngle = this.calcRotationForLegends(pivotData.colKeys);
      }
      opts = $.extend(true, {}, defaults, opts);
      this.setBase(opts);
      this.setChartOpts(chartOpts);
      fullAggName = pivotData.aggregatorName;
      if (pivotData.valAttrs.length) {
        fullAggName += `(${pivotData.valAttrs.join(", ")})`;
      }
      keys = assignRowColumnKeys(pivotData, fullAggName);
      vAxisTitle = fullAggName;
      if (keys.headers.length * keys.rowKeys.length > 4000) {
        keys.colKeys = [];
        keys.columns = [];
        keys.headers = [];
        keys.rowKeys = [];
        showCrashMessage = true;
      }
      if (
        keys.headers.length * keys.rowKeys.length === 0 ||
        (keys.headers.length * keys.rowKeys.length === 1 &&
          keys.headers[0] === "null" &&
          keys.rowKeys[0][0] === "null")
      ) {
        showNoDataMessage = true;
      }
      const formatter = pivotData.getAggregator([], []).format;
      const legends = hideExtralegends(pivotData);
      params = this.getParams(
        legends,
        chartOpts,
        vAxisTitle,
        "",
        rotationAngle,
        opts,
        formatter
      );
      this.updateParams(
        chartOpts,
        params,
        keys.headers,
        keys.columns,
        fullAggName,
        keys.colKeys,
        keys.rowKeys
      );
      return this.updateRenderArea(params, showCrashMessage, showNoDataMessage);
    };
  }

  private calcRotationForLegends(colKeys: string[][]): number {
    const concatStrArray = colKeys.map((x: any) =>
      x.join("_").toLocaleString()
    );
    concatStrArray.sort((a: any, b: any) => {
      return b.length - a.length;
    });
    const longestStr = concatStrArray[0];
    if (concatStrArray.length * longestStr.length < 40) {
      return 0;
    } else if (concatStrArray.length * longestStr.length < 240) {
      return -45;
    } else if (concatStrArray.length * longestStr.length < 480) {
      return -75;
    }
    return -90;
  }
  private setBase(opts: any) {
    let base;
    let base1;
    let base2;
    if ((base = opts.c3).size == null) {
      base.size = {};
    }
    if ((base1 = opts.c3.size).width == null) {
      base1.width = window.innerWidth / 3.2;
    }
    if ((base2 = opts.c3.size).height == null) {
      base2.height = window.innerHeight / 4.2;
    }
  }
  private setChartOpts(chartOpts: any) {
    if (chartOpts.type == null) {
      chartOpts.type = "line";
    }
    if (chartOpts.horizontal == null) {
      chartOpts.horizontal = false;
    }
    if (chartOpts.stacked == null) {
      chartOpts.stacked = false;
    }
  }
  private updateRenderArea(
    params: any,
    showCrashMessage: boolean,
    showNoDataMessage: boolean
  ) {
    const renderArea = $("<div>", {
      style: "display:none;",
    }).appendTo($("body"));
    const result = $("<div>").appendTo(renderArea);
    params.bindto = result[0];
    c3.generate(params);
    this.setChartPath();
    result.detach();
    renderArea.remove();
    if (showCrashMessage) {
      return $("<div>").append(
        "The data visualization you requested is too complex to display. Please either change the chart type or reduce the attributes you selected."
      );
    } else if (showNoDataMessage) {
      return $("<div>").append(
        "The visual presentation you requested contains <b> no data </b>." +
          "Please either change the filters selection or reduce the attributes you selected."
      );
    } else {
      return $("<div>").append("", result);
    }
  }
  private numberFormatter(value: any): any {
    return !isNaN(value) ? value.toLocaleString() : value;
  }
  private getParams(
    legends: any,
    chartOpts: any,
    vAxisTitle: any,
    hAxisTitle: any,
    rotationAngle: any,
    opts: any,
    formatter: any
  ) {
    let params;
    params = {
      axis: {
        rotated: chartOpts.horizontal,
        x: {
          label: hAxisTitle,
          tick: {
            multiline: false,
            rotate: rotationAngle,
          },
        },
        y: {
          label: vAxisTitle,
          tick: {},
        },
      },
      color: {
        pattern: [
          "#dc4941",
          "#444852",
          "#b4bbcb",
          "#6488ff",
          "#41c49d",
          "#5c56e8",
          "#e88e5e",
          "#38699f",
          "#408182",
          "#514b90",
          "#854b4b",
          "#e60028",
          "#23558c",
          "#cccccc",
          "#009bcd",
          "#bcf7cd",
          "#b2e1f0",
          "#ffd6b0",
          "#f7b2be",
        ],
      },
      data: {
        order: null,
        type: chartOpts.type,
      },
      legend: {
        hide: legends,
      },
      tooltip: {
        grouped: false,
        contents(d: any, defaultTitleFormat: any) {
          return setToolTip(d, defaultTitleFormat, formatter);
        },
      },
    };
    params = $.extend(true, {}, params, opts.c3);
    params.axis.x.type = "category";
    if (params.axis.y.tick.format == null) {
      params.axis.y.tick.format = (v: any) => {
        return this.numberFormatter(v);
      };
    }
    return params;
  }

  // tslint:disable-next-line: parameters-max-number
  private updateParams(
    chartOpts: any,
    params: any,
    headers: any,
    columns: any,
    // tslint:disable-next-line: no-shadowed-variable
    fullAggName: any,
    colKeys: any,
    rowKeys: any
  ) {
    this.updateParamsCategories(
      chartOpts,
      params,
      headers,
      columns,
      fullAggName
    );
    this.updateParamsGropus(chartOpts, params, colKeys, rowKeys);
  }

  private updateParamsCategories(
    chartOpts: any,
    params: any,
    headers: any,
    columns: any,
    // tslint:disable-next-line: no-shadowed-variable
    fullAggName: any
  ) {
    if (chartOpts.horizontal) {
      let categories = (() => {
        let len5;
        let n;
        let results;
        let c;
        results = [];
        for (n = 0, len5 = columns.length; n < len5; n++) {
          c = columns[n];
          results.push(c.shift());
        }
        return results;
      })();
      if (categories.length === 1 && categories[0] === fullAggName) {
        categories = [""];
      }
      params.axis.x.categories = categories;
      if (headers.length === 1 && headers[0] === "") {
        headers = [fullAggName];
      }
      columns.unshift(headers);
      params.data.rows = columns;
    } else {
      params.axis.x.categories = headers;
      params.data.columns = columns;
    }
  }
  private updateParamsGropus(
    chartOpts: any,
    params: any,
    colKeys: any,
    rowKeys: any
  ) {
    let x;
    if (chartOpts.stacked) {
      if (chartOpts.horizontal) {
        params.data.groups = [
          (() => {
            let len5;
            let n;
            let results;
            results = [];
            for (n = 0, len5 = colKeys.length; n < len5; n++) {
              x = colKeys[n];
              results.push(x.join("-"));
            }
            return results;
          })(),
        ];
      } else {
        params.data.groups = [
          (() => {
            let len5;
            let n;
            let results;
            results = [];
            for (n = 0, len5 = rowKeys.length; n < len5; n++) {
              x = rowKeys[n];
              results.push(x.join("-"));
            }
            return results;
          })(),
        ];
      }
    }
  }

  private setChartPath() {
    const paths = document
      .getElementsByClassName("c3")[0]
      .getElementsByClassName("domain");
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < paths.length; i++) {
      let attr = paths[i].getAttribute("d");
      if (attr && attr.indexOf("V0H") > -1) {
        attr = HandleCasesWithAndWithoutDash(attr);
      }
      if (attr && attr.indexOf("H0V") > -1) {
        attr = `${attr.substring(0, 2)}1${attr.substring(3, attr.length - 1)}1`;
      }
      if (attr && attr.indexOf(",") === -1) {
        attr = this.augmentAttrInNonCommaScenario(attr);
      }
      paths[i].setAttribute("d", attr ? attr : "");
    }
  }

  private augmentAttrInNonCommaScenario(attr: string) {
    if (attr.length > 2) {
      attr = `${attr.substring(0, 2)},${attr.substring(2, attr.length)}`;
    } else {
      attr = `M0,${attr}`;
    }
    return attr;
  }
}
// tslint:disable-next-line: no-shadowed-variable
function assignRowColumnKeys(pivotData: any, fullAggName: any) {
  let rowKeys;
  let colKeys;
  let headers;
  let columns;
  rowKeys = pivotData.getRowKeys();
  if (rowKeys.length === 0) {
    rowKeys.push([]);
  }
  colKeys = pivotData.getColKeys();
  if (colKeys.length === 0) {
    colKeys.push([]);
  }
  headers = (() => {
    let i;
    let len;
    let results;
    results = [];
    let h;
    for (i = 0, len = colKeys.length; i < len; i++) {
      h = colKeys[i];
      results.push(h.join("-"));
    }
    return results;
  })();
  let numCharsInHAxis = 0;
  let k;
  let len2;
  let x;
  let l;
  let len3;
  let rowKey;
  let rowHeader;
  let row;
  let m;
  let len4;
  let colKey;
  let val;
  for (k = 0, len2 = headers.length; k < len2; k++) {
    x = headers[k];
    numCharsInHAxis += x.length;
  }
  columns = [];
  for (l = 0, len3 = rowKeys.length; l < len3; l++) {
    rowKey = rowKeys[l];
    rowHeader = rowKey.join("-");
    row = [rowHeader === "" ? fullAggName : rowHeader];
    for (m = 0, len4 = colKeys.length; m < len4; m++) {
      colKey = colKeys[m];
      val = parseFloat(pivotData.getAggregator(rowKey, colKey).value());
      if (isFinite(val)) {
        row.push(val);
      } else {
        row.push(null);
      }
    }
    columns.push(row);
  }
  return {
    colKeys,
    columns,
    headers,
    rowKeys,
  };
}

function HandleCasesWithAndWithoutDash(attr: string) {
  if (attr.indexOf("-") > -1) {
    attr = `${attr.substring(0, 4)}1${attr.substring(5, attr.length - 1)}1`;
  } else {
    attr = `${attr.substring(0, 3)}1${attr.substring(4, attr.length - 1)}1`;
  }
  return attr;
}

function hideExtralegends(pivotData: any) {
  const arr = pivotData.rowKeys;
  const legendsToShow = GetLegendsToShow(pivotData.rowAttrs.length);
  if (arr.length > legendsToShow) {
    const smallArr: any = [];
    for (let i = legendsToShow; i < arr.length; i++) {
      const legendArray = arr[i];
      const legend =
        legendArray.length > 1 ? GetLegendValue(legendArray) : legendArray[0];
      smallArr[i - legendsToShow] = legend;
    }
    return smallArr;
  }
  return false;
}

function GetLegendsToShow(attrCount: number): number {
  if (attrCount === 1) {
    return 15;
  } else if (attrCount === 2) {
    return 10;
  } else {
    return 5;
  }
}
function GetLegendValue(legendArray: any[]): string {
  let legend = legendArray[0];
  for (let j = 1; j < legendArray.length; j++) {
    legend = `${legend}-${legendArray[j]}`;
  }
  return legend;
}

function setToolTip(d: any, defaultTitleFormat: any, formatter: any) {
  const titleFormat = defaultTitleFormat;
  const nameFormat = (n: any) => n;
  let text;
  let name;

  for (let i = 0; i < d.length; i++) {
    if (!(d[i] && (d[i].value || d[i].value === 0))) {
      continue;
    }
    if (!text) {
      const title = sanitise(titleFormat ? titleFormat(d[i].x) : d[i].x);
      text = GetToopTipTitle(title);
    }
    const value = formatter(d[i].value);
    if (value !== undefined) {
      if (d[i].name === null) {
        continue;
      }
      name = sanitise(nameFormat(d[i].name));
      text = GetToolTipText(text, d, i, name, value);
    }
  }
  return text + "</table>";
}

// tslint:disable-next-line:max-classes-per-file
export class TableRenderers {
  public tableRenderers = {
    "Col Heatmap": this.controlCrash(),
    Heatmap: this.controlCrash(),
    "Row Heatmap": this.controlCrash(),
    Table: this.controlCrash(),
    "Table Barchart": this.controlCrash(),
  };

  private controlCrash() {
    return (data: any, opts: any) => {
      const keys = assignRowColumnKeys(data, fullAggName);
      if (keys.headers.length * keys.rowKeys.length >= 10000) {
        return $("<div>").append(
          "The data visualization you requested is too complex to display. Please either change the chart type or reduce the attributes you selected."
        );
      } else if (
        keys.headers.length * keys.rowKeys.length === 0 ||
        (keys.headers.length * keys.rowKeys.length === 1 &&
          keys.headers[0] === "null" &&
          keys.rowKeys[0][0] === "null")
      ) {
        return $("<div>").append(
          "The visual presentation you requested contains <b> no data </b>." +
            "Please either change the filters selection or reduce the attributes you selected."
        );
      }
    };
  }
}
function GetToolTipText(text: any, d: any, i: number, name: any, value: any) {
  text += `<tr class='c3-tooltip-${d[i].id}'><td class='name'><b>${name}&nbsp;</b></td>`;
  text += `<td class='value'>${value}${
    fullAggName.indexOf("K€") > -1
      ? " " + fullAggName.substr(fullAggName.length - 3, 2)
      : fullAggName.indexOf("Mln€") > -1
      ? " " + fullAggName.substr(fullAggName.length - 5, 4)
      : fullAggName.indexOf("KUSD") > -1
      ? " " + fullAggName.substr(fullAggName.length - 5, 4)
      : fullAggName.indexOf("MlnUSD") > -1
      ? " " + fullAggName.substr(fullAggName.length - 7, 6)
      : ""
  }</td>`;
  text += "</tr>";
  return text;
}

function GetToopTipTitle(title: any) {
  return title || title === 0
    ? `<table class='c3-tooltip'><tr><th colspan='2'> ${title} </th></tr>`
    : `<table class='c3-tooltip'>`;
}
